"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var crypto_1 = __importDefault(require("crypto")); // Return the hex-encoded md5 hash of `inputString`


function md5(inputString) {
  return crypto_1["default"].createHash("md5").update(inputString).digest("hex");
}

exports["default"] = md5;